"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var AirtableError =
/** @class */
function () {
  function AirtableError(error, message, statusCode) {
    this.error = error;
    this.message = message;
    this.statusCode = statusCode;
  }

  AirtableError.prototype.toString = function () {
    return [this.message, '(', this.error, ')', this.statusCode ? "[Http code " + this.statusCode + "]" : ''].join('');
  };

  return AirtableError;
}();

module.exports = AirtableError;